import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)
 

const opts = {}

export default new Vuetify({
  
    theme: {
      themes: {
        light: {
          primary: '#222222',
          secondary: '#d8d8d8',
          accent: '#9a2a27',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      },
    },
  
});


